<style scoped lang="sass">
.content
  padding: 0 var(--base-padding)
  .pool-stats-link
    display: block
    text-align: right
    margin-bottom: 0.25rem
.bold
  font-weight: 700
.pool-leaderboard-table
  .row
    cursor: pointer
  .column
    .pool-participation-count-wrapper
      .pool-participation-count
        color: white
        display: flex
        justify-content: center
        align-items: center
        background-color: var(--gold)
        width: 1.5rem
        height: 1.5rem
        border-radius: 0.75rem
        margin-left: 0.5rem
    img
      width: 22px
      height: 22px
      border-radius: 11px
    &:nth-child(3)
      flex-grow: 3 !important
.footnote-stats
  display: flex
  justify-content: space-between
  align-items: center
  font-size: 1.2rem
  .joined-invited-stats
    font-weight: 300
  .invite-friends
    font-weight: 600
</style>
<template>
<div id="pool-leaderboard">
  <pool-participation :pool="pool" v-if="pool && pool.participation"></pool-participation>
  <div class="content">
    <a href="#" @click.prevent="statsTray = true" v-if="tournamentStarted" class="pool-stats-link">Pool Stats ></a>
    <pinhigh-table
        :headers="['POS', 'PTS', 'PLAYER']"
        :rows="pool.pool_leaderboard || []"
        v-if="tournamentStarted"
        class="pool-leaderboard-table"
      >
      <template slot="headers" slot-scope="props">
        <div class="column" v-for="(header,i) in props.headers" :key="i">
          {{header}}
          <span class="pool-participation-count-wrapper">
            <span class="pool-participation-count" v-if="header === 'PLAYER'">{{pool.pool_leaderboard.length}}</span>
          </span>
        </div>
      </template>
      <template slot="row" slot-scope="props">
        <div class="row" @click.prevent="openMathModal(props.row)">
          <div class="column">{{props.row.position | pinhighDisplayPlayerPosition({tie: props.row.tie})}}</div>
          <div class="column">{{props.row.points}}</div>
          <div class="column">
            <div class="ellipsis-overflow" :class="{bold: props.row.user.username === $store.getters['currentUser'].username}">
              {{props.row.user.short_informal_name}} ({{props.row.user.username}})
            </div>
          </div>
        </div>
      </template>
    </pinhigh-table>
    <div v-if="!tournamentStarted">
      <div class="footnote-stats">
        <div class="joined-invited-stats">
          {{pool.pool_leaderboard.length}} Joined - {{pool.participations.length - pool.pool_leaderboard.length}} Invited
        </div>
        <a href="#" @click.prevent="toggleInviteFriends" class="invite-friends" v-if="isInvitable">Invite Friends</a>
      </div>
      <pinhigh-table
          :rows="pool.pool_leaderboard"
          class="pool-leaderboard-table-hollow"
          :header-enabled="false"
        >
        <template slot="row" slot-scope="props">
          <div class="row">
            <div class="column">
              {{props.row.user.short_informal_name}} ({{props.row.user.username}})
            </div>
          </div>
        </template>
      </pinhigh-table>
    </div>
    <math-modal v-if="mathModal" :on-close="closeMathModal" :participation="mathModal"></math-modal>
    <invite-friends :pool="pool" :on-close="toggleInviteFriends" v-if="inviteFriends"></invite-friends>
    <stats-tray v-if="statsTray" @close="statsTray = false"></stats-tray>
  </div>
</div>
</template>

<script>
import ordinal           from 'ordinal';
import moment            from 'moment';

import PoolParticipation from './pool-participation.vue';
import MathModal         from './math-modal.vue';
import InviteFriends     from './invite-friends.vue';
import StatsTray         from './stats-tray.vue';

export default {
  name: 'PoolLeaderboard',
  components: {
    PoolParticipation,
    MathModal,
    InviteFriends,
    StatsTray
  },
  props: {
    pool: Object
  },
  data() {
    return {
      mathModal: null,
      inviteFriends: false,
      statsTray: false
    };
  },
  computed: {
    tournamentStarted() {
      return moment().isAfter(this.pool.tournament.start_time);
    },
    isInvitable() {
      return !this.pool.private || this.pool.owner.username === this.$root.currentUser.username;
    }
  },
  methods: {
    ordinal,
    openMathModal(participation) {
      this.mathModal = participation;
    },
    closeMathModal() {
      this.mathModal = null;
    },
    toggleInviteFriends() {
      this.inviteFriends = !this.inviteFriends;
    }
  }
};
</script>
